import { render, staticRenderFns } from "./cDataCaptureRequisitions.vue?vue&type=template&id=1c6e0048&scoped=true"
import script from "./cDataCaptureRequisitions.vue?vue&type=script&lang=js"
export * from "./cDataCaptureRequisitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6e0048",
  null
  
)

export default component.exports